// import Vue from 'vue'
import Store from '@/store'
import { isRefreshExpiredError, refreshSession } from '@/providers/apollo/refresh'
import { redirectToExpired } from '@/plugins/logged-user/loggedUser'
// import sendSlackFireNotifier from '@/plugins/slack-fire-notifier'

const BASE_URL = process.env.VUE_APP_BASE_URL

const defaultHeaders = () => {
  return {
    'Content-Type': 'application/json',
  }
}

const isSessionError = async (response) => {
  if (response.status === 403) return true
  try {
    const data = await response.clone().json()
    return data?.error === 'Acesso não autorizado'
  } catch (e) {
    return false
  }
}

let refreshPromise

const fetchRefreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = refreshSession().finally(() => {
      refreshPromise = null
    })
  }
  return refreshPromise
}

export async function authFetch(url, options = {}) {
  let headers = {
    ...options.headers,
  }

  let response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  })

  if (await isSessionError(response)) {
    try {
      await fetchRefreshSession()

      response = await fetch(url, {
        ...options,
        headers,
        credentials: 'include',
      })

      if (await isSessionError(response)) {
        redirectToExpired()
      }
    } catch (err) {
      if (isRefreshExpiredError(err)) {
        redirectToExpired()
      }
      throw err
    }
  }

  return response
}

const responseHandler = (response) => {
  if (!response.ok) {
    if (response.status === 403) {
      window.location.replace('/#/expired-session')
      throw Error(response.status)
    }
    if (response.status === 406) {
      let json = response.json()
      json.then((object) => {
        Store.dispatch('setExpectedRecoveryDate', object.expected_recovery_date)
        window.location.replace('/#/maintenance')
      })
      throw Error(response.status)
    }
    throw Error(response.status)
  }
  return response
}
const successHandler = (response) => {
  try {
    let json = response.json()
    if (response.status >= 200 && response.status < 300) {
      return json
    }
    // if (response.status === 500) {
    //   window.location.replace('/#/someting-wrong')
    // }
    return json.then(Promise.reject.bind(Promise))
  } catch (e) {
    throw e
  }
}

const errorHandler = async (error) => {
  // const vm = {
  //   $loggedUser: Vue.loggedUser,
  //   $route: Vue.currentRoute,
  //   $options: {
  //     __file: Vue.currentRoute?.matched?.at(-1)?.components?.default?.__file
  //   },
  // }

  // const request = { context: { uri: BASE_URL } }

  // await sendSlackFireNotifier({
  //   title: 'Erro requisição http',
  //   error: error.message,
  //   vm,
  //   info: '',
  //   operation: '',
  //   request,
  // })
  throw error
}

export const get = (endpoint, objectId = '', headers = defaultHeaders()) => {
  return authFetch(`${BASE_URL}${endpoint}${objectId}`, {
    method: 'GET',
    headers,
  })
    .then(responseHandler)
    .then(successHandler)
    .catch(errorHandler)
}

export const getFile = (endpoint, fileName, object, isKpi = false, headers = defaultHeaders()) => {
  return authFetch(`${BASE_URL}${endpoint}`, {
    method: isKpi ? 'POST' : 'GET',
    headers,
    body: isKpi ? JSON.stringify(object) : null,
  })
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = `${fileName}.csv`
      a.click()
    })
    .catch(errorHandler)
}

export const post = (endpoint, object, headers = defaultHeaders()) => {
  return authFetch(`${BASE_URL}${endpoint}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(object),
  })
    .then(successHandler)
    .catch(errorHandler)
}

export const remove = (endpoint, objectId = '', headers = defaultHeaders()) => {
  return authFetch(`${BASE_URL}${endpoint}${objectId}`, {
    method: 'DELETE',
    headers,
  })
    .then(successHandler)
    .catch(errorHandler)
}

export const put = (endpoint, object, headers = defaultHeaders()) => {
  return authFetch(`${BASE_URL}${endpoint}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(object),
  })
    .then(successHandler)
    .catch(errorHandler)
}
